<div class="tile-card-structure forecast-service-table-block mt-4">
  <div class="forcast-tile">
    <div class="application-label">
      <p class="m-0">Forecast Service Management</p>
    </div>
    <div class="forecast-options">
      @if (dataSource && dataSource.data.length) {
      <button
        (click)="expandAllFunc()"
        class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
      >
        {{ allRowsExpanded ? 'Collapse All' : 'Expand All' }}
      </button>
      }
      <div class="export-link ms-2" (click)="exportToExcel()">
        <span
          title="Click to Download"
          class="uitk-icon uitk-icon-download md-icon excel_Download excelandinfo-Icon-font"
        ></span>
      </div>
    </div>
  </div>
  @if (dataSource?.data?.length > 0) {
  <div class="table-container mt-2">
    <app-maintenance-table-v4
      [TABLE_CONFIG]="TABLE_CONFIG"
      [COLUMNS]="TABLE_COLUMNS"
      [expanded_columns]="expanded_columns"
      [dataSource]="dataSource"
      [childDataSource]="dataSource"
      [expandAll]="expandAll"
      [isExpandIconAtStart]="isExpandIconAtStart"
      [pageSize]="TABLE_CONFIG.pageSize"
      (collapseAll)="collapseAllFunc($event)"
      [pageIndex]="TABLE_CONFIG.pageIndex"
      (ColomnDataLob)="onEdit($event)"
    >
    </app-maintenance-table-v4>
  </div>
  }
</div>

<ng-container>
  <app-modal
    [maximizable]="true"
    [inViewport]="true"
    #addEditForsecastServiceModal
    class="modal-demo add-forecast-modal"
    (closeModal)="closeModal()"
  >
    <ng-container class="app-modal-header">
      <div style="display: flex;width: 100%;">
        <div class="forcast-heading">
          Edit Service
        </div>
        <div style="display: flex; align-items: center;"></div>
      </div>
    </ng-container>
    <ng-container class="app-modal-body">
      @if (showForecastModal) {
      <div>
        <app-add-edit-forecast-service
          [editData]="selectedEditData"
          [category]="category"
          [publicPrivate]="publicPrivate"
          [isEdit]="isEdit"
          (updateSerivceTable)="refreshTableData($event)"
        ></app-add-edit-forecast-service>
      </div>
      }
    </ng-container>
  </app-modal>
</ng-container>
